module.exports = __webpack_public_path__ + "img/DSC07355-min.c3e559d8.jpg";